import { useState } from "react";
import {
  Inroduction,
  ProductPartners,
  UseByChildren,
  PersonalInformationWeCollect,
  PersonalInformationUses,
  PersonalInformationSharingAndDisclosures,
  NoticeToCaliforniaResidents,
  HowWeSecurePersonalInformation,
  ExercisingYourRights,
  LinksToOtherPartiesWebsites,
  ContactingUsWithQuestions,
  AmendmentsToThisPolicy,
} from "./components";

interface IDefaultBoolean {
  [key: string]: boolean;
  productPartners: boolean;
  useByChildren: boolean;
  personalInformationWeCollect: boolean;
  personalInformationUses: boolean;
  personalInformationSharingAndDisclosures: boolean;
  noticeToCaliforniaResidents: boolean;
  howWeSecurePersonalInformation: boolean;
  exercisingYourRights: boolean;
  linksToOtherPartiesWebsites: boolean;
  contactingUsWithQuestions: boolean;
  amendmentsToThisPolicy: boolean;
}

const defaultBoolean = {
  productPartners: false,
  useByChildren: false,
  personalInformationWeCollect: false,
  personalInformationUses: false,
  personalInformationSharingAndDisclosures: false,
  noticeToCaliforniaResidents: false,
  howWeSecurePersonalInformation: false,
  exercisingYourRights: false,
  linksToOtherPartiesWebsites: false,
  contactingUsWithQuestions: false,
  amendmentsToThisPolicy: false,
};

export const EN = () => {
  const [shows, setIsShows] = useState<IDefaultBoolean>(defaultBoolean);

  const onToggle = (itemName: string) => {
    setIsShows((prev) => ({ ...prev, [itemName]: !prev[itemName] }));
  };

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold">PRIVACY POLICY</h1>
      <p className="pt-2 pb-4">Last modified: March 12, 2025</p>
      <Inroduction />
      <ProductPartners
        onToggle={() => onToggle("productPartners")}
        isShow={shows.productPartners}
      />
      <UseByChildren
        onToggle={() => onToggle("useByChildren")}
        isShow={shows.useByChildren}
      />
      <PersonalInformationWeCollect
        onToggle={() => onToggle("personalInformationWeCollect")}
        isShow={shows.personalInformationWeCollect}
      />
      <PersonalInformationUses
        onToggle={() => onToggle("personalInformationUses")}
        isShow={shows.personalInformationUses}
      />
      <PersonalInformationSharingAndDisclosures
        onToggle={() => onToggle("personalInformationSharingAndDisclosures")}
        isShow={shows.personalInformationSharingAndDisclosures}
      />
      <NoticeToCaliforniaResidents
        onToggle={() => onToggle("noticeToCaliforniaResidents")}
        isShow={shows.noticeToCaliforniaResidents}
      />
      <HowWeSecurePersonalInformation
        onToggle={() => onToggle("howWeSecurePersonalInformation")}
        isShow={shows.howWeSecurePersonalInformation}
      />
      <ExercisingYourRights
        onToggle={() => onToggle("exercisingYourRights")}
        isShow={shows.exercisingYourRights}
      />
      <LinksToOtherPartiesWebsites
        onToggle={() => onToggle("linksToOtherPartiesWebsites")}
        isShow={shows.linksToOtherPartiesWebsites}
      />
      <ContactingUsWithQuestions
        onToggle={() => onToggle("contactingUsWithQuestions")}
        isShow={shows.contactingUsWithQuestions}
      />
      <AmendmentsToThisPolicy
        onToggle={() => onToggle("amendmentsToThisPolicy")}
        isShow={shows.amendmentsToThisPolicy}
      />
    </div>
  );
};
